/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlGetZeroDayAlertSampleFileResponse
 */
export interface ControlGetZeroDayAlertSampleFileResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlGetZeroDayAlertSampleFileResponse
     */
    presigned_url: string;
}

/**
 * Check if a given object implements the ControlGetZeroDayAlertSampleFileResponse interface.
 */
export function instanceOfControlGetZeroDayAlertSampleFileResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "presigned_url" in value;

    return isInstance;
}

export function ControlGetZeroDayAlertSampleFileResponseFromJSON(json: any): ControlGetZeroDayAlertSampleFileResponse {
    return ControlGetZeroDayAlertSampleFileResponseFromJSONTyped(json, false);
}

export function ControlGetZeroDayAlertSampleFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetZeroDayAlertSampleFileResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'presigned_url': json['presigned_url'],
    };
}

export function ControlGetZeroDayAlertSampleFileResponseToJSON(value?: ControlGetZeroDayAlertSampleFileResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'presigned_url': value.presigned_url,
    };
}

